module.exports = __webpack_public_path__ + "img/nav-close.e87b7933.svg";